// DON'T IMPORT ANYTHING THAT IS LINKED INTO ANY COMPONENT OR THE STORE
import { EntityAsset, Program, TimeZoneDetails } from '../../../globals/store/programs.data';
import { AUS_SYD_TIMEZONE, DAY_MS } from '../../../globals/helpers/constants'
import { JoiEvent } from '../../../globals/store/events.data';
import { PublicEventData } from '../../../globals/store/public.model';
import { errorTexts } from './error-helpers';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AllSameKeySetEnforcer, AllSameKeyValueTypesEnforcer, AllSameKeyValuesEnforcer, AllSameKeysAsPropertyValueEnforcer, AllSameKeysEnforcer, AllSameKeysEnforcerWithValue, AllSameKeysToTypeEnforcer, JustTime, flatten, str2Date, updateProgramsAndVenuesInPlace } from './../../../globals/helpers/helpers';
import { findTimeZone, getUTCOffset as rawGetUTCOffset } from 'timezone-support';
export { errorTexts, AllSameKeySetEnforcer, AllSameKeyValueTypesEnforcer, AllSameKeyValuesEnforcer, AllSameKeysAsPropertyValueEnforcer, AllSameKeysEnforcer, AllSameKeysEnforcerWithValue, AllSameKeysToTypeEnforcer, JustTime }


export interface CollapseExpand { [id: string]: 'collapse' | 'expand' }

export const doPrint = () => {
  const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!is_safari) {
      window.print();
  } else {
      console.log('Safari printing ...')
      document.execCommand('print', false, null);
  }
}







export const extractPropValuesAsSet = <T, O>(objectList: O[], key: keyof O): Set<T> => new Set(objectList.map(object => object[key as string]))

export const updateObjectInPlaceWithAllPropertiesOfOtherObject = <O>(one: O, two: O) => {
  Object.keys(two).forEach(key => one[key] = two[key])
}


const getPercent = (chars: number, total: number = 420000) => Math.round(chars/total * 10000) / 100
// this is a very rough way of getting the event size.  It could be calculated exactly, but that would be pretty complicated -
// plus, doing so would necessitate always tracking changes to an event
export const getEventSizeAsPercent = (event: JoiEvent) => getPercent(JSON.stringify(event).length)

export const getPropSizes = (object, maxChildren: number = 10, maxLength: number = 420000) => {
  const children = []
  try {
    const keys = Object.keys(object)
    const total = JSON.stringify(object).length
    keys.forEach(k => {
      const child = object[k]
      if (!child) return

      const chars = JSON.stringify(child).length

      const obj = { 
        percent: getPercent(chars, total), 
        maxPercent: getPercent(chars, maxLength), 
        name: typeof child === 'object' ? child.name || child.title || null : child,
        chars,
        id: k,
        obj: child 
      } as any

      
      if (typeof child === 'object') obj.children = getPropSizes(child, maxChildren, maxLength)
      children.push(obj)
    })
    return children.sort((a,b) => b.percent - a.percent).slice(0,maxChildren)
  } catch (error) {
    return []
  }

}


export const nameJoiner = <P extends { firstName?: string, lastName?: string }>(p: P): string => 
  !p ? '' : `${p.firstName || ''}${p.firstName && p.lastName ? ' ' : ''}${p.lastName || ''}`


export const removeOrAddToListByElement = (list: any[], id: string) => { // toggle functionality for lists
  const index = list.indexOf(id);
  if (index > -1) {
    list.splice(index, 1);
  } else {
    list.push(id);
  }
  return index > -1 // removed
}

export const removeFromListByIndex = (list: any[], index) => {
  console.log({ list, index })
  if (index > -1) {
    list.splice(index, 1)
  }
}

export const removeUniqueStringFromList = (list: string[], uniqueString: string) =>
  removeFromListByIndex(list, list.findIndex(str => str === uniqueString))

export const filterListByUniqueProp = <T, K extends keyof T>(list: T[], idProp: K): T[] => {
  const uniqueIds = new Set()
  return list.filter(el => {
    const id = el[idProp]
    return uniqueIds.size !== uniqueIds.add(id).size
  })
} 


// Similar to copyObjectWithProps but allows for shallow validating of dot noted values going to firebase. eg. user.firstName instead of user:{firstName:...} and overrideing the user object
export const cleanEntry = <O>(entry: O, white_list: Array<keyof O>): O => {
  const clean_entry = {} as O
  // console.log({ entry: jsonCopyObject(entry) })
  white_list.forEach(key => {
    if (entry.hasOwnProperty(key) && entry[key] !== undefined) {
      clean_entry[key] = entry[key];
    }
  })
  // console.log({ clean_entry: jsonCopyObject(clean_entry )})
  // what the heck is this supposed to do?
  Object.keys(entry).filter(k => k.includes('.')).forEach(compound_key => {
    const key = compound_key.split('.')[0] as keyof O;
    if (white_list.indexOf(key)) clean_entry[compound_key] = entry[compound_key];
  })
  // console.log({ clean_entry: jsonCopyObject(clean_entry )})

  return clean_entry;
}

  



const getClassElements = (elementsOfClass: string) => Array.from(document.getElementsByClassName(elementsOfClass))
const getIdElement = (elementOfId: string) => document.getElementById(elementOfId)

export const addClassToElementOfId = (elementOfId: string, classToAdd: string) =>
  getIdElement(elementOfId).classList.add(classToAdd)

export const removeClassFromElementOfId = (elementOfId: string, classToRemove: string) =>
  getIdElement(elementOfId).classList.remove(classToRemove)

export const addClassToElementsOfOtherClass = (elementsOfClass: string, classToAdd: string) =>
  getClassElements(elementsOfClass).forEach((el: HTMLElement) => el.classList.add(classToAdd))

export const removeClassFromElementsOfOtherClass = (elementsOfClass: string, classToRemove: string) =>
  getClassElements(elementsOfClass).forEach((el: HTMLElement) => el.classList.remove(classToRemove))



export const updateComponentWithObject = (comp, obj) => Object.entries(obj).forEach(([key, value]) => comp[key] = value)

export const combineSets = <T extends unknown>(sets: Set<T>[]): Set<T> => {
  const combinedSet = new Set(sets[0])
  if (sets.length < 2) return combinedSet
  sets.sort((s1,s2) => s2.size - s1.size) // biggest sets come first
  let i = 1
  while (i < sets.length) {
    sets[i].forEach(el => combinedSet.add(el))
    i++
  }
  return combinedSet
} 


export const storageUrlToPath = url => {
  const a = url.split(".com/o/");
  const b = a[1] ? a[1] : a[0];
  return decodeURIComponent(b.split("?")[0])
}

export const loadLocal = <T>(key, defaultValue: T = null) =>
  window.localStorage[key] ? JSON.parse(window.localStorage[key]) : defaultValue

export const saveLocal = (key, jsonStorageObject) =>
  window.localStorage[key] = JSON.stringify(jsonStorageObject)

export const sortFirebaseTimestamps = (t1, t2) =>
  t1.seconds * 1000000 + t1.nanoseconds - t2.seconds * 1000000 - t2.nanoseconds


export const listOfIdsToEmptyObjectsMap = (list): { [id: string]: {} } =>
  Object.assign({}, ...list.map(el => ({ [el]: {} })))
export const listOfIdsToEmptySetsMap = <SetType extends unknown>(list): { [id: string]: Set<SetType> } => Object.assign({}, ...list.map(el => ({ [el]: new Set() })))
export const listOfIdsToEmptyListsMap = <ListType extends unknown>(list): { [id: string]: ListType[] } => Object.assign({}, ...list.map(el => ({ [el]: [] })))

export const setToIdentityMap = (set): { [index: string]: string } => Object.assign({}, ...Array.from(set).map((el: string) => ({ [el]: el })))

export const filterSetByProp = (set, prop): Set<string> => !set ? new Set() : new Set(<string[]>Array.from(set).filter(p => p !== prop))

export const getTwoDeepValue = <T, K1 extends keyof T, K2 extends keyof T[K1]>(prop1: K1, prop2: K2, input: T) => {
    if (input === null || input === undefined) return undefined
    if (input[prop1] === null || input[prop1] === undefined) return undefined
    return input[prop1][prop2]
  }

export const getTwoDeepSet = <T, K1 extends keyof T, K2 extends keyof T[K1]>(objectList: T[], prop1: K1, prop2: K2) =>
  new Set(objectList.map(o => getTwoDeepValue(prop1, prop2, o)).filter(v => v))

export const getOrderedEntities = <T>(objectMap: { [id: string]: T }, ids: string[]): T[] => ids.map(id => objectMap[id]).filter(o => o)



export const subTilDestroy = <C extends StoreWithDestroy>
  (that: C, selector, propOrCallback: keyof C | Function, destroySubject: Subject<boolean> = null) => that.store.pipe(selector, takeUntil(destroySubject || that.$destroy)).subscribe(val =>
    typeof propOrCallback === 'function' ? propOrCallback(val) : that[propOrCallback as string] = val
  )


export const oneDayApart = (dateString1: string, dateString2: string) => {
  const diff = str2Date(dateString1).getTime() - str2Date(dateString2).getTime()
  return Math.abs(diff) === DAY_MS
}



export const pausePromise = (pauseMilliseconds = 0) => new Promise((resolve, reject) => setTimeout(() => resolve(null), pauseMilliseconds))


export const capitalize = s => s.length === 0 ? s : s.charAt(0).toUpperCase() + s.slice(1, s.length)

export const titleCase = s => s.split(" ").map(capitalize).join(" ")

export const filterByKeywordAndProps = <T>(keyword: string, propList: (keyof T)[]) => {
  keyword = keyword ? keyword.toLocaleUpperCase() : keyword
  return (object: T) => !keyword ? object : propList.some(p => object[p] && (object[p] as unknown as string).toLocaleUpperCase().includes(keyword))
}

export const weekDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const filterByExactKeywordAndProps = (keyword: string, propList: string[]) => {
  keyword = keyword ? keyword.toLocaleUpperCase() : keyword
  return object => !keyword ? object : propList.some(p => object[p] && object[p].toLocaleUpperCase() === keyword)
}

export const deleteUndefinedEntriesInPlace = object => Object.keys(object).forEach(key => {
  if (object.hasOwnProperty(key) && object[key] === undefined) {
    delete object[key]
  }
})

export const deleteFalseEntriesInPlace = object => Object.keys(object).forEach(key => {
  if (object.hasOwnProperty(key) && !object[key]) {
    delete object[key]
  }
})

export type BooleanFunction = () => boolean

export const makePresentationAssetId = (asset: EntityAsset) => `${asset.created}` // obviously not very comprehensive, just for use in checking if NEW assets are coming in.  Probably should have a unique id on the presentation assets instead

export const logWithKey = key => result => { console.log({ [key]: result }) }

export const addDefaultValueForEmptyProps = (object, requiredProps, defaultValue = '') => requiredProps.forEach(prop => {
  if (!object.hasOwnProperty(prop)) object[prop] = defaultValue
})

interface Heights { twenty, thirty, forty, fifty }
export const HEIGHTS: AllSameKeysEnforcer<Heights> = { twenty: '20px', thirty: '30px', forty: '40px', fifty: '50px' }

export const getXYFromEventAndWidth = (event: MouseEvent, dialogWidth: number) => {
  let { x, y } = event
  x = Math.max(1, x - dialogWidth / 2)
  x = x > window.innerWidth - 20 - dialogWidth ? window.innerWidth - 20 - dialogWidth : x
  y = y + 27 // so the dialog can appear below the click (if there is enough space)
  y = document.body.clientHeight - y > 400 ? y : Math.max(1, document.body.clientHeight - 400)
  return { x, y }
}


export const getTimeZoneDetails = (() => {
  const detailsById:{ [id: string]: TimeZoneDetails } = {}
  return (timeZoneId: string, date: Date): TimeZoneDetails => {
    const dateTime = date.getTime()
    const id = `${timeZoneId}:${dateTime - dateTime%DAY_MS}`
    if (detailsById[id]) return detailsById[id]
    const timezone = findTimeZone(timeZoneId);
    const theUtcobj = rawGetUTCOffset(new Date(date), timezone);
    const offset = theUtcobj.offset / 60 * -1;
    const hours = Math.abs(Math.floor(offset));
    const minutes = Math.abs(offset * 60 % 60);
    const offsetText = (offset < 0 ? '-' : '+')+(hours > 9 ? hours : '0'+hours) + ':' + (minutes > 9 ? minutes : '0'+minutes)
    const timeZoneDetails: TimeZoneDetails = { days: [], timeZoneId, offset: offset * -1, abbr: theUtcobj.abbreviation, offsetText }
    detailsById[id] = timeZoneDetails
    return timeZoneDetails
  }
})()

export const getTimeZonedDateFromUTCTimeAndTimeZoneId = (time: number, timeZoneId: string) => {
  const timezone = findTimeZone(timeZoneId)
  const timezoneDate = new Date(new Date(time).toLocaleString("en-US", {timeZone: timezone.name }))
  return timezoneDate
}

export const getHHMMFromUTCTimeAndTimezoneId = (time: number, timeZoneId: string) => {
  const timezoneDate = getTimeZonedDateFromUTCTimeAndTimeZoneId(time, timeZoneId)
  const h = timezoneDate.getHours()
  const m = timezoneDate.getMinutes()
  return `${ h > 9 ? h : '0' + h}:${ m > 9 ? m : '0' + m }`
}




interface TimelineParents { facilitator, snapshot, program }
export const timelineParents: AllSameKeyValuesEnforcer<TimelineParents> = { facilitator: 'facilitator', snapshot: 'snapshot', program: 'program' }

export const sleepForMS = ms => new Promise(resolve => setTimeout(() => resolve(true), ms))

export const onlyWhitespace = (text: string) => !Array.from(text).some(c => c.charCodeAt(0) > 32)


// I got the next several functions from stack overflow.  Not sure if they work right yet. 
export const isElement = (node: Node, name: string) => node.nodeType === Node.ELEMENT_NODE && (name == null || node.nodeName.toLocaleLowerCase() === name.toLocaleLowerCase())

export const isBr = (node: Node | null) => isElement(node, 'br');

export const isDivWithBr = (node: Node) =>
  isElement(node, 'div') && node.childNodes.length === 1 && isBr(node.lastChild);

export const parseAsText = (main_node: Node) =>
  Array.from(main_node.childNodes)
    .map((node: Node): any => {
      if (isBr(node) || isDivWithBr(node)) {
        return '\n';
      }
      return isElement(node, 'div')
        ? (node.previousSibling ? '\n' : '') + parseAsText(node)
        : node.textContent;
    })
    .join('');

export const copyTitle = (title: string, titlesToCompare: string[]): string => {
  const title_base = title.replace(/^Copy (of|\d+) /,'')
  const copyNumbers = titlesToCompare.filter(t => t.replace(/^Copy (of|\d+) /,'') === title_base)
    .map(t => t.split(' '))
    .map(titleWords => titleWords[0] === 'Copy' ? titleWords[1] : null)
    .map(copy => !copy ? 0 : copy === 'of' ? 1 : +copy)
    .map(n => isNaN(n) ? 0 : n)
  const max = Math.max(...copyNumbers)
  //  console.log({ title_base, copyNumbers, max, title, titlesToCompare })
  return !max ? `Copy of ${title_base}` : `Copy ${max + 1} ${title_base}`
}

export const listsMatch = (listA: string[], listB: string[]): boolean => 
  listA.length !== listB.length ? false : !listA.some(str => !listB.includes(str))

export const getYFromEstimatedHeightAndRect = (estimatedHeight: number, rect: DOMRect) => {
  const fitsBelow = (window.innerHeight - rect.bottom) >= estimatedHeight + 5
  const fitsAbove = rect.top - estimatedHeight - 5 >= 5
  // console.log({ estimatedHeight, fitsBelow, fitsAbove, rect, innerHeight: window.innerHeight })
  return fitsBelow ? rect.bottom + 5 : fitsAbove ? rect.top - estimatedHeight - 5 : null
}

export const blobFromUrl = async(url) => await fetch(url, { cache: 'no-store' }).then(async r => {
  try {
    const blob = await r.blob()
    return blob
  } catch (error) {
    console.log("Error fetching blob from URL: ", error)
    throw error
  }
})

export const makeStringFileNameSafe = (s: string): string => 
  s.replace(/[^a-z0-9_ \.\-\(\)]/gi, '_').replace(/_{2,}/g, '_')

export const downloadFromBlob = (blob: Blob, fileName: string) => {
  const link = document.createElement('a')
  const url = window.URL.createObjectURL(blob)
  link.href = url
  link.download = makeStringFileNameSafe(fileName)
  link.click()
  window.URL.revokeObjectURL(url)
}

export const saveStringToFile = (s: string, fileName: string) =>
  downloadFromBlob(new Blob([s], { type: "text/plain;charset=utf-8" }), fileName)

const SPECIAL_CSV_CHARS = ['"', ',', '\n', '\r']
export const escapeCSVCell = (s: string): string => {
  if (typeof s !== 'string') {
    console.log("Invalid string: ", s)
    s = s + ""    
  }
  let needsQuotes = false
  const newStringChars = s.split("").map(c => {
    const isSpecial = SPECIAL_CSV_CHARS.includes(c)
    if (isSpecial) needsQuotes = true
    return c === '"' ? '""' : c.replace("\n", "\t").replace("\r", "\t") // can't fix newlines within exported csvs (not sure why, no good answers I can find for how to do so), changing to tabs
  })
  return needsQuotes ? `"${newStringChars.join("")}"` : s
}

export const save2DStringArrayToCSVFile = (s2DArray: string[][], fileName: string) =>
  saveStringToFile(s2DArray.map(row => row.map(escapeCSVCell).join(",")).join("\n"), fileName)

export const downloadAndRenameFromUrl = async(url: string, fileName: string) => {
  try {
    const blob = await blobFromUrl(url)
    downloadFromBlob(blob, fileName)
  } catch (error) {
    console.log("SOMETHING WENT WRONG IN downloadAndRenameFrom", error)
  }
}

export const getProgramDayOrDateByFilterIdConstructor = (programEntities: { [pId:string]: Program }) => (id: string) => {
  const [ programId, day ] = id.split(":")
  const program = programEntities[programId]
  if (!program.date) return `Day ${day}`
  return new Date(str2Date(program.date).getTime() + DAY_MS * (+day - 1))
}


export function assertNever(x: never): never {
  throw new Error("Unexpected object: " + x)
}

export const addScriptToDocumentBySource = (src: string) => {
  const script = document.createElement('script')
  script.src = src
  script.async = true;
  script.defer = true;
  document.head.appendChild(script)
}

export const starLog = (log: string) => {
  const baseLog = `*   ${log}   *`
  const n = baseLog.length
  const emptyLine = `\n*  ${" ".repeat(n-6)}  *`
  const stars = `\n${"*".repeat(n)}`
  console.log(`${stars}${emptyLine}\n${baseLog}${emptyLine}${stars}`)
}

export const openGoogleMapByLatLngPlaceId = (place_id: string) => {
  // https://www.google.com/maps/place/?q=place_id:ChIJp4JiUCNP0xQR1JaSjpW_Hms
  const url = `https://www.google.com/maps/place/?q=place_id:${place_id}`
  console.log({ url })
  window.open(url, '_blank')
}

export const updateOldPublishedEventInPlace = (d: PublicEventData, defaultTimeZoneId: string = AUS_SYD_TIMEZONE) => {
  if (!defaultTimeZoneId) defaultTimeZoneId = AUS_SYD_TIMEZONE
  d.timeZoneIdsByProgram = d.timeZoneIdsByProgram || {}
  d.timeline = d.timeline || []
  d.eventInfo.venues = d.eventInfo.venues || {}
  const programs: Program[] = flatten(d.timeline).map(item => item.program as Program)
  d.eventInfo.venues = d.eventInfo.venues || {}
  updateProgramsAndVenuesInPlace(d.eventInfo.venues, programs, defaultTimeZoneId)
  programs.filter(p => !d.timeZoneIdsByProgram[p.id] && !!p.date).forEach(p => d.timeZoneIdsByProgram[p.id] = p.timeZoneDetails ? p.timeZoneDetails.timeZoneId : defaultTimeZoneId)
  if (!d.publishVersion) d.excludedFieldIds.push('homeTab') // publishes before branding had no version.  Future versions can be used for additional things like this
}

export const addTrailingSpace = (s: string) => s ? s + ' ' : ''


export const orderListByIds = <T extends { id: string }>(items: T[], ids: string[]): T[] => { 
  return ids.map(id => items.find(i => i.id === id)).filter(item => item)
}

export const moveIndexItemUpInList = <T>(i: number, list: T[]): T[] =>
  [...list.slice(0, i-1), list[i], list[i-1], ...list.slice(i+1,)]
 
export const moveIndexItemDownInList = <T>(i: number, list: T[]): T[] =>
  [...list.slice(0, i), list[i+1], list[i], ...list.slice(i+2,)]

export const deleteIndexItemFromList = <T>(i: number, list: T[]): T[] =>
  [...list.slice(0, i), ...list.slice(i+1,)]

export const deleteItemFromListById = (id: string, list: string[]): string[] =>
   deleteIndexItemFromList(list.findIndex(e => e === id), list) 

export const getNumberFromText = (text: string | number, defaultNumber: number = 0) => {
  let number: number
  try {
    number = !text ? null : Math.round(+text * 100) / 100 // no zeros, otherwise input behaves strangely
    if (isNaN(number) || !number) number = defaultNumber
  } catch {
    number = defaultNumber
  }
  return number
}

export const getBeginningOfMonthDate = (date: Date) => {
  date = new Date(date)
  date.setHours(0, 0, 0, 0)
  date.setDate(1)
  return date
}

export const getDefaultAccountBudgetStartDate = () => { 
  const date = new Date()
  date.setMonth(date.getMonth() - 11)
  return getBeginningOfMonthDate(date)
}

export const urlIsValid = (url: string): boolean => !url || url.includes('http://') || url.includes('https://') // extracting so this can be improved at some point and used everywhere

export const quillHTMLToText = (quillText: string) => quillText && quillText.split ? quillText.split("</p><p>").join("\n").replace(/<.*?>/g, p => "") : ""

export const hexIsLight = (color: string): boolean => {
  const hex = color.replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return brightness > 155;
}

export const makeDefaultLabels = () => [
  { id: 'default01', label: '', color: '#54DDC7', name: 'Green' }, 
  { id: 'default02', label: '', color: '#FFD157', name: 'Yellow' },
  { id: 'default03', label: '', color: '#FF8A5C', name: 'Orange' }, 
  { id: 'default04', label: '', color: '#F05454', name: 'Red' },
  { id: 'default05', label: '', color: '#8270DB', name: 'Purple' }, 
  { id: 'default06', label: '', color: '#A6DBFF', name: 'Blue' }
]

export const transpose = <T>(matrix: T[][]): T[][] => matrix[0].map((col, i) => matrix.map(row => row[i])) 

export const generateEmailLink = (subject: string, body: string, emailAddress: string = '') => {
  const s = encodeURIComponent(subject)
  const b = encodeURIComponent(body)
  return `mailto:${emailAddress || ''}?subject=${s}&body=${b}`
} 

export const removeDiacritics = (str) => {
  if (!str) return ''
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export interface StoreWithDestroy {  store: Store, $destroy: Subject<any> }

export const subCallback = <T, C extends StoreWithDestroy>(that: C, obs: Observable<T>, callback: (val: T) => void, destroySubject: Subject<boolean> | null = null) =>
  obs.pipe(takeUntil(destroySubject || that.$destroy)).subscribe((val: T) => callback(val))